import { IColumnProps } from 'taltech-styleguide';
import {
  colCourseLogoDefaults,
  colCreatedDateDefaults,
  colDescriptionDefaults,
  colEmailDefaults,
  colEndDateDefaults,
  colEnumDefaults,
  colFirstNameDefaults,
  colIdDefaults,
  colInitialsDefaults,
  colLastNameDefaults,
  colLecturerDefaults,
  colMaxDefaults,
  colMinDefaults,
  colModifiedDateDefaults,
  colNameDefaults,
  colNumberDefaults,
  colRoleDefaults,
  colStartDateDefaults,
  colStateDefaults,
  colSubmissionsDefaults,
  colTitleDefaults,
  columnDefaultProps,
  colValueDefaultDefaults,
} from './Col.defaults';
import { ColumnBuilder } from './Col.types';
import { createColumnProps } from './Col.utils';

export const columBuilder: ColumnBuilder = (
  props,
  defaults = columnDefaultProps
) => {
  return createColumnProps(defaults, props) as IColumnProps;
};

export const columBuilderFactory: (
  props: Partial<IColumnProps>
) => (props?: Partial<IColumnProps>) => IColumnProps = (colDefaults) => {
  return (props?: Partial<IColumnProps>) => {
    const defaults = createColumnProps(columnDefaultProps, colDefaults);
    if (props === undefined) {
      return defaults as IColumnProps;
    } else {
      return createColumnProps(defaults, props) as IColumnProps;
    }
  };
};

export const cols = {
  id: columBuilderFactory(colIdDefaults),
  number: columBuilderFactory(colNumberDefaults),
  name: columBuilderFactory(colNameDefaults),
  firstName: columBuilderFactory(colFirstNameDefaults),
  lastName: columBuilderFactory(colLastNameDefaults),
  description: columBuilderFactory(colDescriptionDefaults),
  type: columBuilderFactory(colEnumDefaults),
  createdDate: columBuilderFactory(colCreatedDateDefaults),
  modifiedDate: columBuilderFactory(colModifiedDateDefaults),
  startDate: columBuilderFactory(colStartDateDefaults),
  endDate: columBuilderFactory(colEndDateDefaults),
  valueDefault: columBuilderFactory(colValueDefaultDefaults),
  min: columBuilderFactory(colMinDefaults),
  max: columBuilderFactory(colMaxDefaults),
  courseLogo: columBuilderFactory(colCourseLogoDefaults),
  lecturer: columBuilderFactory(colLecturerDefaults),
  email: columBuilderFactory(colEmailDefaults),
  title: columBuilderFactory(colTitleDefaults),
  submissions: columBuilderFactory(colSubmissionsDefaults),
  state: columBuilderFactory(
    createColumnProps(colEnumDefaults, { dataField: 'state', name: 'State' })
  ),
  class: columBuilderFactory(
    createColumnProps(colEnumDefaults, { dataField: 'class', text: 'Class' })
  ),
  role: columBuilderFactory(colRoleDefaults),
  initials: columBuilderFactory(colInitialsDefaults),
  stateTag: columBuilderFactory(colStateDefaults),
  build: (props: Partial<IColumnProps>) =>
    createColumnProps(columnDefaultProps, props),
  custom: columBuilderFactory({})
};

export type ColumnType = [keyof typeof cols];
